import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiShipmentsOptions,
  type GetApiShipmentsError,
  type PageOfShipmentDto,
} from '@/api';

import {
  toShipmentsQuery,
  type ResolvedShipmentsSearch,
} from '../lib/searchParams';

/** Отгрузки в работе - страница по фильтрам из адресной строки. */
export const useShipmentsInWork = (
  resolved: ResolvedShipmentsSearch,
  // Тип возврата задан явно (TS2742), как у справочника товара.
): UseQueryResult<PageOfShipmentDto, GetApiShipmentsError> =>
  useQuery({
    ...getApiShipmentsOptions({ query: toShipmentsQuery(resolved) }),
    placeholderData: (previous) => previous,
  });
